import React from "react";
import PartyForm from "./PartyForm";

export default function PartyCreateForm({ type }) {
  return <PartyForm type={type} />;
}
